import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import lax from 'lax.js';
import { FormattedMessage } from 'react-intl';
import { ModalHeader } from '@bibliocommons/modal';
import { SecondaryGhostButton } from '@bibliocommons/base-buttons';
import { PlayCircleOutline } from '@bibliocommons/base-icons';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import { MOVIE_DB_IMG_BASE_PATH, YOUTUBE_EMBED_URL } from 'app/constants/MoviesConstants';
import './MovieTrailer.scss';

const MODAL_KEY = 'movie-trailer-modal';

export default class MovieTrailer extends React.PureComponent {
  componentDidMount() {
    lax.init();
    lax.addDriver('scrollY', () => window.scrollY);

    // TODO: Add animation bindings to elements
    // lax.addElements()
  }

  // componentWillUnmount() {
  //   // TODO: Remove animation bindings to elements
  //   // lax.removeElements();
  // }

  handleOpen = () => {
    this.props.modalActions.openModal(MODAL_KEY, { authRequired: false });
  };

  handleClose = () => {
    this.props.modalActions.closeModal(MODAL_KEY);
  };

  renderButton() {
    return (
      <SecondaryGhostButton
        className="trailer-button"
        dataKey="trailer-button"
        handleClick={this.handleOpen}
        renderLeadingIcon={() => <PlayCircleOutline />}
      >
        <FormattedMessage id="watch_trailer" />
      </SecondaryGhostButton>
    );
  }

  renderBackDrop() {
    const backdropPath = this.props.movie.get('backdropPath');

    return (
      backdropPath && (
        <img
          alt=""
          className="backdrop-image lax"
          data-lax-translate-y="400 -150, 0 0"
          src={`${MOVIE_DB_IMG_BASE_PATH}/${backdropPath}`}
          loading="lazy"
        />
      )
    );
  }

  renderPlayer() {
    const videoSrc = this.props.movie.getIn(['videos', 'results', 0, 'key']);

    return (
      videoSrc && (
        <ModalContainer modalKey={MODAL_KEY} handleClose={this.handleClose} bodyClassName="trailer-modal">
          <div>
            <ModalHeader title={<FormattedMessage id="watch_trailer" />} />
            <iframe src={`${YOUTUBE_EMBED_URL}/${videoSrc}`} frameBorder="0" allowFullScreen />
          </div>
        </ModalContainer>
      )
    );
  }

  render() {
    const player = this.renderPlayer();
    const backdrop = this.renderBackDrop();

    if (player && backdrop) {
      return (
        <div className="cp-movie-trailer">
          {this.renderButton()}
          <div className="backdrop-wrapper">{backdrop}</div>
          {player}
        </div>
      );
    }

    return null;
  }
}

MovieTrailer.propTypes = {
  movie: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
